import { mountVueComponent } from '@/lib/mount-vue-component';

export default () =>
  import('@/modules/panel/components/PanelForm').then(PanelForm => mountVueComponent('panel-form', PanelForm));
